import React, { useEffect, useState } from "react";
import { getFile } from "../../../../utils/getFile";
import config from "../../../../config";
import * as yup from "yup";
import User from "../../../../assets/img/icons/user1.png";
import { useParams } from "react-router-dom";
import { decrypt } from "../../../../utils/crypto";
import api from "../../../../api/axios";
import moment from "moment"; 

const reviewCycleSchema = yup.object().shape({
  comment: yup.string().required("*Comment is required"),
});

const EmployeePIP = ({ activeTab }) => {
  const [profileImage, setProfileImage] = useState(null);
  const [reviewCycles, setReviewCycles] = useState([]);
  const [errors, setErrors] = useState({});
  const { employee_id } = useParams();
  const [pipDetails, setPipDetails] = useState({});

  const getPipData = async () => {
    try {
      const decryptedId = await decrypt(employee_id);
      const response = await api.get(`api/pip-detail/${decryptedId}`);
      setPipDetails(response?.data?.data || {});
      console.log('response?.data?.data', response?.data?.data);
    } catch (error) {
      console.error("Error fetching PIP data:", error);
    }
  };

  useEffect(() => {
    getPipData();
  }, []);

  useEffect(() => {
    const fetchImage = async () => {
      let image = null;
      if (pipDetails.photo) {
        try {
          const imageUrl = await getFile(
            `${config.IMAGE_URL}${pipDetails.photo}`
          );
          if (imageUrl) {
            image = imageUrl;
          }
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      }
      setProfileImage(image || User); // Fallback to default User image
    };

    fetchImage();

    // Update review cycles when pipDetails changes
    if (pipDetails?.review_cycles) {
      const updatedCycles = pipDetails.review_cycles.map((cycle) => ({
        ...cycle,
        editMode:
          cycle.performance === "" && cycle.comment === "" ? true : false,
      }));
      setReviewCycles(updatedCycles);
    } else {
      setReviewCycles([]); 
    }
  }, [pipDetails]); 

  const today = new Date();

  const [loading ,setLoading] = useState(false);
  const [currentPipId , setCurrentPipId] = useState(null);
  const handleSaveOrUpdate = async (id) => {
    const cycle = reviewCycles.find((c) => c.id === id);
    setCurrentPipId(cycle?.id)
    const reviewed_by = localStorage.getItem("employeeID");

    try {
      setLoading(true);
      await reviewCycleSchema.validate(
        { performance: cycle.performance, comment: cycle.comment },
        { abortEarly: false }
      );
      setErrors((prev) => ({ ...prev, [id]: {} }));
      const data = {
        cycle: cycle,
        pip_record_id: id,
        reviewed_by: reviewed_by,
        comment: cycle.comment,
        performance: cycle.performance || null,
      };
      const response = await api.post(`api/pip-review`, data);
      getPipData();
      setReviewCycles((prev) =>
        prev.map((c) =>
          c.id === id
            ? {
              ...c,
              editMode: false,
              reviewd_date: today.toISOString().split("T")[0],
            }
            : c
        )
      );
    } catch (err) {
      if (err.inner) {
        const cycleErrors = {};
        err.inner.forEach((e) => {
          cycleErrors[e.path] = e.message;
        });
        setErrors((prev) => ({ ...prev, [id]: cycleErrors }));
      }
    }
    finally{
      setLoading(false);
    }
  };

  const handleReEdit = (id) => {
    setReviewCycles((prev) =>
      prev.map((cycle) =>
        cycle.id === id ? { ...cycle, editMode: true } : cycle
      )
    );
  };

  const handleChange = (id, field, value) => {
    setReviewCycles((prev) =>
      prev.map((cycle) =>
        cycle.id === id ? { ...cycle, [field]: value } : cycle
      )
    );
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return "N/A";
    // Assuming dateValue is a Unix timestamp in seconds (int)
    const date = moment.unix(dateValue);
    return date.format("DD-MMM-YYYY");
  };

  function isToday(review_cycle_start_date) {
    const activeDate = new Date(review_cycle_start_date);
    const isActive = activeDate <= today;

    if (isActive) {
      return true
    }
    return false;
  }

  return (
    <div className="tab-content profileSection pt-0" style={{ paddingTop: "0px" }}>
      <div
        id="pip"
        className={`pro-overview tab-pane fade ${activeTab === "pip" ? "show active" : ""
          }`}
      >
        <div className="row">
          <div className="col-md-12 d-flex">
            <div className="card profile-box flex-fill">
              <div className="card-body">
                {reviewCycles?.length > 0 && reviewCycles[0]?.reviewd_date && (
                  <h4 className="mt-4">Review Cycles</h4>
                )}
                {reviewCycles?.length > 0 ? (
                  reviewCycles?.map((cycle, index) => {
                    const activeDate = new Date(cycle?.review_cycle_start_date);
                    const isActive = activeDate <= today;

                    return (
                      <div className="card mt-3" key={cycle.id}>
                        <div className="card-header d-flex align-item-center justify-content-between">
                          <div>
                            <strong>Review Cycle {index + 1}</strong> (
                            <span className="text-secondary">
                              {cycle.review_cycle_start_date}
                            </span>
                            ){!isActive && <span className="badge bg-warning ms-2">Not Yet Active</span>}
                          </div>
                          {!cycle.editMode && isActive && (
                            <div className="text-end">
                              <button
                                className="m-0 p-0 border-0 bg-white"
                                onClick={() => handleReEdit(cycle.id)}
                              >
                                <i className="fa-solid fa-pen-to-square cursor-pointer text-primary"></i>
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="card-body pt-0">
                          {!isActive ? (
                            <div className="alert alert-info">
                              This review cycle will be available from {cycle.review_cycle_start_date}. You will be notified via email when it becomes active.
                            </div>
                          ) : cycle.editMode ? (
                            <>
                              <div className="mb-2">
                                <label>Write Your Comment</label>
                                <textarea
                                  className="form-control"
                                  rows={3}
                                  value={cycle.comment}
                                  onChange={(e) =>
                                    handleChange(
                                      cycle.id,
                                      "comment",
                                      e.target.value
                                    )
                                  }
                                />
                                {errors[cycle.id]?.comment && (
                                  <div className="text-danger">
                                    {errors[cycle.id].comment}
                                  </div>
                                )}
                              </div>
                              <div className="text-end mb-3">
                                <button
                                  className="btn btn-success"
                                  onClick={() => handleSaveOrUpdate(cycle.id)}
                                  disabled = { currentPipId == cycle?.id  ? loading ? true : false : false}
                                >
                                  {cycle?.comment
                                    ? currentPipId == cycle?.id ? loading ? "Updating..." : "Update" : "Update"
                                    : currentPipId == cycle?.id ? loading ? "Saving.." : "Save" : "Save"}
                                </button>
                              </div>

                              {/* Feedbacks section in edit mode */}
                              {cycle.feedbacks &&
                                cycle.feedbacks.length > 0 && (
                                  <div className="mt-4">
                                    <h6>Feedbacks</h6>
                                    {cycle.feedbacks.map((feedback, fIndex) => (
                                      <div
                                        key={fIndex}
                                        className="border p-3 mb-2 bg-light"
                                      >
                                        <p>
                                          <strong>Reviewer:</strong>{" "}
                                          {feedback.reviewer_first_name}{" "}
                                          {feedback.reviewer_middle_name || ""}{" "}
                                          {feedback.reviewer_last_name}
                                        </p>
                                        <p>
                                          <strong>Comment:</strong>{" "}
                                          {feedback.reviewer_comment}
                                        </p>
                                        <p>
                                          <strong>Status:</strong>{" "}
                                          <span
                                            className={` badge ${feedback?.review_status ==
                                                "Approved"
                                                ? "bg-success"
                                                : "bg-danger"
                                              }`}
                                          >
                                            {" "}
                                            {feedback.review_status}
                                          </span>
                                        </p>
                                        <p>
                                          <strong>Created:</strong>{" "}
                                          {formatDate(
                                            feedback.review_created_at
                                          )}
                                        </p>
                                        <p>
                                          <strong>Updated:</strong>{" "}
                                          {formatDate(
                                            feedback.review_updated_at
                                          )}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                )}
                            </>
                          ) : (
                            <>
                              <div className="row">
                                <div className="col-md-12 col-12">
                                  <p>
                                    <span>Your Comment : </span>
                                    <span className="text-secondary">
                                      {cycle.comment}
                                    </span>
                                  </p>
                                </div>
                                <div className="col-md-12 col-12">
                                  <p>
                                    <span>Commented On : </span>
                                    <span className="text-secondary">
                                      {cycle.reviewd_date || "N/A"}
                                    </span>
                                  </p>
                                </div>
                              </div>

                              {/* Feedbacks section in view mode */}
                              {cycle.feedbacks &&
                                cycle.feedbacks.length > 0 && (
                                  <div className="row mt-3">
                                    <div className="col-12">
                                      <h5 className="mb-2">Feedbacks</h5>
                                      {cycle.feedbacks.map(
                                        (feedback, fIndex) => (
                                          <div
                                            key={fIndex}
                                            className="border p-3 mb-2 bg-light"
                                          >
                                            <p>
                                              <strong>Reviewer:</strong>{" "}
                                              {feedback.reviewer_first_name}{" "}
                                              {feedback.reviewer_middle_name ||
                                                ""}{" "}
                                              {feedback.reviewer_last_name}
                                            </p>
                                            <p>
                                              <strong>Comment:</strong>{" "}
                                              {feedback.reviewer_comment}
                                            </p>
                                            <p>
                                              <strong>Status:</strong>{" "}
                                              <span
                                                className={` badge ${feedback?.review_status ==
                                                    "Approved"
                                                    ? "bg-success"
                                                    : "bg-danger"
                                                  }`}
                                              >
                                                {" "}
                                                {feedback.review_status}
                                              </span>
                                            </p>
                                            <p>
                                              <strong>Created:</strong>{" "}
                                              {formatDate(
                                                feedback.review_created_at
                                              )}
                                            </p>
                                            <p>
                                              <strong>Updated:</strong>{" "}
                                              {formatDate(
                                                feedback.review_updated_at
                                              )}
                                            </p>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                )}
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="alert alert-info text-center">
                    No PIP review cycles available.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeePIP;
